import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import CustomModal from "../../../components/generic/custommodal/CustomModal";
import CreateOrganization from "./CreateOrganization";
import SecondaryButton from "../../../components/generic/buttons/SecondaryButton";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import apiService from "../../../service/apiservice/apiService";
import { strings } from "../../utils/strings";

const CreateOrganizationModal = forwardRef(
  (
    { openOrganizationModal, setOpenOrganizationModal, action, setRefresh },
    ref
  ) => {
    const [organization, setOrganization] = useState(null);
    const [organizationId, setOrganizationId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);

    useImperativeHandle(ref, () => ({
      setOrganizationData: (newVal) => setOrganization(newVal),
      setOrganizationIdentifier: (id) => setOrganizationId(id),
    }));

    const handleCancel = () => {
      setOpenOrganizationModal(!openOrganizationModal);
      setOrganization({});
      setOrganizationId(null);
    };

    const handlePrimaryClick = async (e) => {
      e.preventDefault();
      setErrors(validate(organization));
      setIsSubmit(true);
    };

    const validate = (values) => {
      const errors = {};
      if (!values?.name) {
        errors.name = "Name is required!";
      }
      if (!values?.completeAddress) {
        errors.completeAddress = "Address is required!";
      }
      return errors;
    };

    const handleSubmit = async () => {
      setLoading(true);
      const endpoint = "niramayafoundation/api/v1/organization";

      const payload = {
        name: organization?.name,
        medicareProviderNumber: organization?.medicareProviderNumber,
        address: organization?.completeAddress,
        notes: organization?.notes,
        telephone: organization?.telephone,
        postalCode: organization?.postalCode,
        streetAddress: organization?.streetAddress,
        addressLocality: organization?.addressLocality,
        addressRegion: organization?.addressRegion,
        addressCountry: organization?.addressCountry,
      };

      const url =
        action === "Update" ? `${endpoint}/${organizationId}` : endpoint;
      const method = action === "Update" ? "put" : "post";
      const successMessage =
        action === "Update"
          ? strings.ORGANIZATION_UPDATE_SUCCESS
          : strings.ORGANIZATION_ADD_SUCCESS;
      const errorMessage =
        action === "Update"
          ? strings.ORGANIZATION_UPDATE_ERROR
          : strings.ORGANIZATION_ADD_ERROR;

      const response = await apiService[method](
        url,
        payload,
        successMessage,
        errorMessage
      );

      if (response?.id) {
        setIsSubmit(false);
        setOrganization(null);
        setOrganizationId(null);
        setOpenOrganizationModal((prev) => !prev);
        setRefresh((prev) => !prev);
      }
      setLoading(false);
    };

    const footerButtons = (
      <>
        <SecondaryButton buttonText={"Cancel"} handleOnClick={handleCancel} />
        <PrimaryButton
          buttonText={action}
          handleOnClick={handlePrimaryClick}
          loading={loading}
        />
      </>
    );

    useEffect(() => {
      if (Object.keys(errors).length === 0 && isSubmit) {
        handleSubmit();
      }
    }, [errors, isSubmit]);

    return (
      <>
        <CustomModal
          closable={false}
          isModalOpen={openOrganizationModal}
          footer={footerButtons}
          closeModal={setOpenOrganizationModal}
        >
          <CreateOrganization
            organization={organization}
            setOrganization={setOrganization}
            errors={errors}
          />
        </CustomModal>
      </>
    );
  }
);

export default CreateOrganizationModal;
